module.exports = __webpack_public_path__ + "static/media/note2.998cc13a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/static/note2.jpeg
// module id = 509
// module chunks = 0